import { inject } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    Router,
    RouterStateSnapshot,
} from '@angular/router';
import { StepNavigationService } from '../../services/step-navigation/step-navigation.service';
import { of, Observable } from 'rxjs';
import { navigateToHome } from '../../../../../core/resolver/shared/functions/navigate-to-home.function';

export const ApplicationPageAccessResolver = (
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
): Observable<boolean> => {
    const stepNavigationService = inject(StepNavigationService);
    const router = inject(Router);

    const url = state.url;

    /**
     * Checks to see if the requested URL is in the set steps for the application.
     */
    if (stepNavigationService.isUrlPathInSetSteps(url)) {
        stepNavigationService.setCurrentStepByPath(url);
        return of(true);
    } else {
        return navigateToHome(router);
    }
};
